import React from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { theme, daltonismTheme, ThemeVariant } from './theme'

interface ThemeProviderProps {
  children?: React.ReactNode
  variant?: ThemeVariant
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  variant = 'default',
}) => {
  const selectedTheme = variant === 'daltonism' ? daltonismTheme : theme

  return (
    <StyledThemeProvider theme={selectedTheme}>
      {children as any}
    </StyledThemeProvider>
  )
}
